import React from 'react';
import { Button } from 'react-bootstrap';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';

/**
 * Title + subtitle on the left, an optional "view all" action and carousel
 * arrows on the right. Shared by the therapists and wiki sections.
 *
 * Pass `onPrev`/`onNext` to render the arrows; omit them for a static header.
 */
export default function SectionHeader({
  eyebrow,
  title,
  subtitle,
  actionLabel,
  onAction,
  onPrev,
  onNext,
  canScrollPrev = true,
  canScrollNext = true,
  controlsLabel = 'carousel',
}) {
  const hasArrows = Boolean(onPrev || onNext);

  return (
    <header className="mm-section-head">
      <div className="mm-section-head__text">
        {eyebrow && <div className="mm-eyebrow mb-2">{eyebrow}</div>}
        <h2 className="mm-h2">{title}</h2>
        {subtitle && <p className="mm-lead mt-2 mb-0">{subtitle}</p>}
      </div>

      {(actionLabel || hasArrows) && (
        <div className="mm-section-head__actions">
          {actionLabel && (
            <Button variant="outline-ink" className="px-3 px-sm-4" onClick={onAction}>
              {actionLabel}
            </Button>
          )}

          {hasArrows && (
            <>
              <button
                type="button"
                className="mm-icon-btn"
                onClick={onPrev}
                disabled={!canScrollPrev}
                aria-label={`Previous ${controlsLabel}`}
              >
                <FiArrowLeft aria-hidden="true" />
              </button>
              <button
                type="button"
                className="mm-icon-btn"
                onClick={onNext}
                disabled={!canScrollNext}
                aria-label={`Next ${controlsLabel}`}
              >
                <FiArrowRight aria-hidden="true" />
              </button>
            </>
          )}
        </div>
      )}
    </header>
  );
}
